<template>
  <div class="developers-index">
    <page-header
      :title="pageTitle"
      :subtitle="`${totals} results found`"
    >
      <template #action>
        <v-btn dark color="blue" class="fw-400" @click="addDeveloper">
          Add
        </v-btn>
      </template>
    </page-header>

    <MultiSelectSearch
      :features="featuresFilters"
      :selected-features="selectedFeatures"
      @search="searchDevelopers"
    />

    <DevelopersDataTable />

    <AddDeveloperModal v-model="isModalVisible" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import MultiSelectSearch from '@/components/MultiSelectSearch.vue';
import DevelopersDataTable from '@/components/Developers/DataTable.vue';
import AddDeveloperModal from '@/components/Developers/AddDeveloperModal.vue';

export default {
  metaInfo: {
    title: 'List of developers',
  },

  components: {
    PageHeader,
    MultiSelectSearch,
    DevelopersDataTable,
    AddDeveloperModal,
  },

  data() {
    return {
      pageTitle: 'List of developers',
      isModalVisible: false,
    };
  },

  computed: {
    ...mapState('hrDevelopers', [
      'totals',
      'selectedFeatures',
    ]),

    ...mapState('features', ['featuresFilters']),
  },

  created() {
    this.fetchFeatures();
    this.fetchDevelopers();
  },

  methods: {
    ...mapActions('hrDevelopers', [
      'fetchDevelopers',
      'setSelectedFeatures',
    ]),

    ...mapActions('features', ['fetchFeatures']),

    addDeveloper() {
      this.isModalVisible = true;
    },

    searchDevelopers(params) {
      this.setSelectedFeatures(params);
      this.fetchDevelopers();
    },
  },
};
</script>

<style lang="scss" scoped></style>
